<template>
  <div class="club-application">
    <el-card class="application-card">
      <div class="card-header">
        <h2>Club Application</h2>
        <div class="club-info">
          <span class="club-name">{{ $route.query.club_name }}</span>
          <span class="club-type">{{ $route.query.club_type }} Club</span>
        </div>
      </div>

      <el-form 
        ref="applicationForm"
        :model="applicationForm"
        :rules="rules"
        label-width="120px"
        class="application-form"
      >
        <el-form-item 
          label="Personal Statement" 
          prop="personal_statement"
        >
          <el-input
            type="textarea"
            v-model="applicationForm.personal_statement"
            :rows="6"
            placeholder="Please describe why you want to join this club and what you can contribute..."
          />
        </el-form-item>

        <el-form-item>
          <el-button 
            type="primary" 
            @click="submitApplication"
            :loading="submitting"
          >
            Submit Application
          </el-button>
          <el-button @click="goBack">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { postRequest } from '@/api/eclub'
import { getUserId } from '@/utils/store'

export default {
  name: 'ClubApplication',
  async created() {
    try {
      const response = await postRequest('getClubApplication', {
        student_id: getUserId(),
        club_id: this.$route.query.club_id
      })
      
      if (response.data.code === 0 && response.data.data) {
        // this.$message.warning('You have already submitted an application for this club')
        this.applicationForm = response.data.data
        // this.$router.back()
      }else if (response.data.code === -1 || !response.data.data) {
        
      }
    } catch (error) {
      console.error('Error checking existing application:', error)
      this.$message.error('Failed to check existing application')
    }
  },
  data() {
    return {
      applicationForm: {
        personal_statement: ''
      },
      rules: {
        personal_statement: [
          { required: true, message: 'Please write your personal statement', trigger: 'blur' },
          { min: 50, message: 'Personal statement must be at least 50 characters', trigger: 'blur' }
        ]
      },
      submitting: false
    }
  },
  methods: {
    async submitApplication() {
      try {
        await this.$refs.applicationForm.validate()
        
        this.submitting = true
        const response = await postRequest('addStudentClubApplication', {
          student_id: getUserId(),
          club_id: this.$route.query.club_id,
          personal_statement: this.applicationForm.personal_statement
        })
        
        if (response.data.code === 0) {
          this.$message.success('Application submitted successfully')
          // this.$router.push('/home/studentclubs')
        } else {
          this.$message.error(response.data.msg || 'Failed to submit application')
        }
      } catch (error) {
        if (error !== false) {
          console.error('Error submitting application:', error)
          this.$message.error('Failed to submit application')
        }
      } finally {
        this.submitting = false
      }
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.club-application {
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;

  .application-card {
    .card-header {
      margin-bottom: 24px;

      h2 {
        margin: 0 0 12px;
        color: #303133;
      }

      .club-info {
        display: flex;
        align-items: center;
        gap: 12px;

        .club-name {
          font-size: 16px;
          color: #409EFF;
        }

        .club-type {
          font-size: 14px;
          color: #909399;
          padding: 2px 8px;
          background: #f5f7fa;
          border-radius: 12px;
        }
      }
    }

    .application-form {
      .el-form-item__content {
        .el-button {
          margin-right: 16px;
        }
      }
    }
  }
}
</style> 